import machineDefaultImage from '../../../images/machineImageEmpty.svg';
import { machineHasImage, machineImageUrl } from '../../../utils/imageProxy';
import EntityPhotoFrame from '../../entityImage/EntityPhotoFrame';
import OpenImageDialog from '../../openImageDialog';
import { Box } from '@mui/material';
import Iconify from '../../Iconify';
import { useState } from 'react';
import '../../../css/machines/machineImageActions.css';

const PublicMachineMachineImage = ({ machineImage }) => {
    const [openImage, setOpenImage] = useState(false);
    const entity = { machine_image: machineImage };
    const hasImage = machineHasImage(entity, { size: 'medium' });

    if (!hasImage) {
        return null;
    }

    const image = Array.isArray(machineImage) ? machineImage[0] : machineImage;
    const imageUrl = machineImageUrl(entity, { size: 'medium', fallback: machineDefaultImage });

    return (
        <Box>
            <EntityPhotoFrame
                image={image}
                src={imageUrl}
                alt="Image de la machine"
                className="machineImageActions_image_icon_box"
            >
                <Iconify
                    className="machineImageActions_maximize_icon"
                    icon="tabler:arrows-maximize"
                    onClick={() => setOpenImage(true)}
                />
            </EntityPhotoFrame>
            {openImage && (
                <OpenImageDialog
                    openImage={openImage}
                    setOpenImage={setOpenImage}
                    profileUrl={imageUrl}
                />
            )}
        </Box>
    );
};

export default PublicMachineMachineImage;
